
import AppDossierEdit from "@/components/dossier/DossierEdit.vue";
import AppDossierUser from "@/components/dossier/DossierUsers.vue";
import AppDossierScripts from "@/components/dossier/DossierScripts.vue";
import AppDossierCalculatedFields from "@/components/dossier/DossierCalculatedFields.vue";
import AppBrowseExtraButtons from "@/components/dossier/DossierBrowseExtraButtons.vue";
import AppDossierAutoSaleRowSettings from "@/components/dossier/DossierAutoSaleRowSettings.vue";
import AppDossierPeppolRegistrationsEdit from "@/components/dossier/DossierPeppolRegistrationsEdit.vue";

import Vue from "vue";

import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { CompanyDossierService } from "@/services/company-dossier-service";
import { CompanyService } from "@/services/company-service";
import { setTitle, resetTitle } from "@/utils/title";


export default Vue.extend({
	data() {
		return {
			currentTab: 0,
			company: new Company(),
			dossier: new Dossier(),
			loaded: false
		};
	},
	computed: {
		tabs():string[] {
			return [
				"Dossier",
				"Users",
				"Scripts",
				"Berekende velden",
				"Browse extra knoppen",
				"Automatische verkoop detail regels",
				"Peppol registraties"
			];
		}
	},
	methods: {
		goToCompany() {
			this.$router.push(`/companies/${this.dossier.companyId}/edit`);
		}
	},
	async created() {
		this.company = await CompanyService.getCompany(parseInt(this.$route.params.companyId));
		if (this.$route.params.dossierId) {
			this.dossier = await CompanyDossierService.getDossier(this.company.id, parseInt(this.$route.params.dossierId));
		}
		setTitle(this.dossier.name);
		this.dossier.companyId = this.company.id;
		this.loaded = true;

		//if current tab is set go to and remove querry from url
		if (this.$route.query.currentTab) {
			this.currentTab = parseInt(this.$route.query.currentTab[0] || "0");
			let query = Object.assign({}, this.$route.query);
			delete query.currentTab;
			this.$router.replace({ query });
		}
	},
	destroyed(){
		resetTitle();
	},
	components: {
		AppDossierEdit,
		AppDossierUser,
		AppDossierScripts,
		AppDossierCalculatedFields,
		AppBrowseExtraButtons,
		AppDossierAutoSaleRowSettings,
		AppDossierPeppolRegistrationsEdit
	}
});
